import React from 'react';
import { H3, H4, Modal, NamedLink } from '../../../components';
import Icons from '../../../components/Icons/Icons';
import { useIntl } from '../../../util/reactIntl';
import css from './SubscriptionCard.module.css';
import { getUserFirstName } from '../../../util/userDataExtraction';

function ConfirmationModal({
  onManageDisableScrolling,
  isConfirmationModalOpen,
  setIsConfirmationModalOpen,
  currentUser,
}) {
  const intl = useIntl();
  const firstName = getUserFirstName(currentUser);

  const messages = {
    heading: intl.formatMessage(
      {
        id: 'ConfirmationModal.WelcomeHeading',
        defaultMessage: 'Welcome to LandVnV, {firstName}!',
      },
      { firstName }
    ),
    message: intl.formatMessage({
      id: 'ConfirmationModal.WelcomeMessage',
      defaultMessage: 'Your provider account is now active — and your first month is on us.',
    }),
    listTitle: intl.formatMessage({
      id: 'ConfirmationModal.ListTitle',
      defaultMessage: 'You can now:',
    }),
    listItems: [
      intl.formatMessage({
        id: 'ConfirmationModal.ListItem1',
        defaultMessage: 'Create and publish your first service listing',
      }),
      intl.formatMessage({
        id: 'ConfirmationModal.ListItem2',
        defaultMessage: 'Start connecting with clients in your area',
      }),
      intl.formatMessage({
        id: 'ConfirmationModal.ListItem3',
        defaultMessage: 'Manage bookings, set availability, and build your reputation',
      }),
    ],
    closing: intl.formatMessage({
      id: 'ConfirmationModal.ClosingMessage',
      defaultMessage:
        'We’re excited to have you on board and can’t wait to see your services in action.',
    }),
    createListing: intl.formatMessage({
      id: 'ConfirmationModal.CreateListingButton',
      defaultMessage: 'Create Your First Listing',
    }),
    dashboard: intl.formatMessage({
      id: 'ConfirmationModal.DashboardButton',
      defaultMessage: 'Go to Dashboard',
    }),
  };

  return (
    <Modal
      className={css.accountComlpetionSuccessModal}
      id="ConfirmationModal"
      isOpen={isConfirmationModalOpen}
      onClose={setIsConfirmationModalOpen}
      onManageDisableScrolling={onManageDisableScrolling}
    >
      <div className={css.verificationModalContent}>
        <div className={css.successIcon}>
          <Icons name="checkListIcon" />
        </div>
        <H3 as="h1" className={css.heading}>
          &#127881;
          {messages.heading}
        </H3>
        <p>{messages.message}</p>
        <div className={css.otherInfo}>
          <H4 as="h4">{messages.listTitle}</H4>
          <ul className={css}>
            {messages.listItems.map((item, index) => (
              <li key={index}>
                <Icons name="checkListIcon" />
                {item}
              </li>
            ))}
          </ul>
        </div>
        <p>{messages.closing}</p>
        <div className={css.linkContainer}>
          <NamedLink name="NewListingPage" className={css.homePageButton}>
            {messages.createListing}
          </NamedLink>
          <NamedLink name="AccountSettingsPage" className={css.homePageButton}>
            {messages.dashboard}
          </NamedLink>
        </div>
      </div>
    </Modal>
  );
}

export default ConfirmationModal;
